/**
 * Created by zhangjingguo on 16/7/12.
 */
import Model from './model'
const model = new Model()

class Purchase {
    static getClazzVipSaleInfos() {
        return model.post('purchase/open/getClazzVipSaleInfos')
    }

    // 获取群组套餐价格
    static getClazzVipPurchaseInfo(clazzId, resId) {
        return model.post(`purchase/getClazzVipPurchaseInfo?clazzId=${clazzId}&resId=${resId}`)
    }

    // 余额支付
    static accountPay(res) {
        return model.postForm(`purchase/accountPay`, res)
    }

    // 购买免费测试
    static getFreePay(params) {
        return model.postForm('purchase/freePay', params)
    }
}

export default Purchase


// WEBPACK FOOTER //
// ./bootsets/models/purchase.js